module.exports = __webpack_public_path__ + "static/media/ArtworkForWebsitRepeat.7bb25730.jpg";